import actionTypes from "./actionType";
import store from "./index";
export const changeStore = data => {
  return {
    type: actionTypes.SAVE_ATTRINFO,
    data
  };
};
export const storeChangeObject = data => {
  return {
    type: actionTypes.SAVE_OBJECT,
    data
  };
};
export const storeMenuType = data => {
  return dispatch => {
    const changeStore = {
      showMenu: data
    };
    if (data) {
      clearTimeout(store.getState().showMenuTime);
      changeStore.showMenuTime = setTimeout(
        () =>
          dispatch(
            storeChangeObject({
              showMenu: false
            })
          ),
        1000 * 2.6
      );
    }
    dispatch(storeChangeObject(changeStore));
  };
};